export default __webpack_public_path__ + "static/media/909.bd671095.gif";